import { User } from 'types/users';
import { weddingPaths, rootPaths } from 'routes/paths';

/**
 * Returns the appropriate home/dashboard path for a user based on their role.
 *
 * @param user The session user object
 * @returns {string} The absolute path to the user's landing page
 */
export const getHomePath = (user: User | null): string => {
  if (!user) return rootPaths.root;

  // Handle admin and couple roles (Organizer view)
  if (user.role === 'admin' || user.role === 'couple') {
    // Unverified couples go to verification first
    if (user.role === 'couple' && user.isEmailVerified === false) {
      return weddingPaths.coupleVerifyEmail;
    }
    return weddingPaths.coupleDashboard;
  }

  // Handle guest / uploader roles
  if (user.role === 'uploader') {
    return user.eventId
      ? weddingPaths.guestDashboard(user.eventId)
      : weddingPaths.guestGalleryGeneral;
  }

  // Default fallback
  return rootPaths.root;
};

/**
 * Checks if a user has permission to access a specific area of the app.
 *
 * @param user The session user object
 * @param pathname The current location pathname
 * @returns {boolean} True if access is allowed
 */
export const isAuthorizedForPath = (user: User | null, pathname: string): boolean => {
  if (!user) return false;

  const isCouplePath = pathname.startsWith(weddingPaths.coupleBase);

  // Guests (uploaders) cannot access couple-specific paths
  if (user.role === 'uploader' && isCouplePath) {
    return false;
  }

  // Future: Add more specific role checks here (e.g. admin-only routes)

  return true;
};
